/**
 * Transforms an array of objects into a standardized format for select options.
 * Each object in the input array is mapped to an object with `value` and `label`
 * properties, where the values of these properties are taken from the properties
 * of the input objects specified by `valueProp` and `labelProp`, respectively.
 *
 * @param {Object} params - The parameters object.
 * @param {Object[]} params.options - An array of objects to be normalized for use as select options.
 * @param {string} params.valueProp - The property name in the objects in `options`
 *                                    that contains the value for each option.
 * @param {string} params.labelProp - The property name in the objects in `options`
 *                                    that contains the display label for each option.
 * @returns {Object[]} An array of objects, where each object has a `value` and `label`
 *                     property corresponding to the properties in the original objects
 *                     specified by `valueProp` and `labelProp`.
 *
 * @example
 * // returns [{ value: 1, label: 'One' }, { value: 2, label: 'Two' }]
 * normalizeSelectOptions({
 *   options: [{ id: 1, name: 'One' }, { id: 2, name: 'Two' }],
 *   valueProp: 'id',
 *   labelProp: 'name'
 * });
 */

const normalizeSelectOptions = ({ options, valueProp, labelProp }) =>
  options.map(option => ({
    value: option[valueProp],
    label: option[labelProp]
  }));

export default normalizeSelectOptions;
